import { FC, useEffect, useState } from 'react';
import { ICommonData } from '@vfit/shared/models';
import VoucherInsertionCard from './components/VoucherInsertionCard/voucherInsertionCard';
import VoucherSuccessCard from './components/VoucherSuccessCard/voucherSuccessCard';
import { useCheckout } from '../../../iBuyFixed.context';
import { ID_FLOWS } from '../../checkout.constants';

export const VoucherCard: FC<ICommonData> = (props) => {
  const { voucher, setCurrentStepKey } = useCheckout();
  const [isValidVaucher, setIsValidVaucher] = useState(
    (voucher?.voucher?.isSuccess &&
      voucher?.shoppingCart?.isSuccess &&
      !voucher?.isInvalidVoucher &&
      !voucher?.isExpiredVoucher) ||
      false
  );

  const checkVoucherValidation = () => {
    if (!voucher.validateVoucher.isSuccess) {
      setIsValidVaucher(false);
    } else if (!voucher?.isExpiredVoucher && !voucher?.isInvalidVoucher) {
      setIsValidVaucher(true);
    }
  };

  useEffect(() => {
    checkVoucherValidation();
  }, [voucher]);

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.VOUCHER);
  }, []);

  if (isValidVaucher) return <VoucherSuccessCard {...props} />;
  return <VoucherInsertionCard {...props} />;
};

export default VoucherCard;
